import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ArchiveLicenseActions from 'archive/ArchiveLicenseActions';
import ArchiveLicenseStore from 'archive/ArchiveLicenseStore';
import connect from 'stores/connect';
import { LicenseStatusPropType } from 'archive/propTypes';
import type { Store } from 'stores/StoreTypes';
import type { LicenseStatus } from 'archive/types';
import InstantArchivingLicenseStatus from 'instant-archiving/InstantArchivingLicenseStatus';

type Props = {
  summary?: boolean,
  licenseStatus: LicenseStatus,
};

const InstantArchivingLicenseStatusContainer = ({ summary, licenseStatus }: Props) => {
  useEffect(() => {
    ArchiveLicenseActions.getLicenseStatus();
  }, []);

  if (licenseStatus.loading) {
    return null;
  }

  return <InstantArchivingLicenseStatus licenseStatus={licenseStatus} summary={summary} />;
};

InstantArchivingLicenseStatusContainer.propTypes = {
  summary: PropTypes.bool,
  licenseStatus: LicenseStatusPropType.isRequired,
};

InstantArchivingLicenseStatusContainer.defaultProps = {
  summary: false,
};

export default connect(InstantArchivingLicenseStatusContainer,
  { licenseStatus: ArchiveLicenseStore as Store<LicenseStatus> });
